import React from 'react';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { SetType } from '../../../shared/constants';
import { useStyles } from './SetTypeIcon.styles';

interface SetTypeIconProps {
  type: SetType;
}

export default function SetTypeIcon(props: SetTypeIconProps) {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <Typography
      variant="text-md"
      className={clsx(classes.typeIcon, classes['type_' + props.type])}
      component="div">
      {props.type[0].toUpperCase()}
    </Typography>
  );
}
